'use strict';

class DocumentoIdentidadContrastacionController {

    constructor($scope, DataService, Datetime, Message, $log) {
        'ngInject';
        this.$scope = $scope;
        this.DataService = DataService;
        this.Datetime = Datetime;
        this.Message = Message;
        this.$log = $log;
    }

    $onInit () {
      if (!this.ngModel) this.ngModel = {};
      this.initDefault('tipo_documento', 'CARNET_IDENTIDAD');
    }

    isCI () {
      return this.ngModel.tipo_documento =='CARNET_IDENTIDAD' || this.ngModel.tipo_documento == 'CARNET_EXTRANJERO';
    }

    isFill () {
      return this.ngModel.id_persona;
    }

    initDefault (key, val) { if (!this.ngModel[key]) this.ngModel[key] = val; }

    changeType() {
        this.nombreDel();
    }

    nombreDel () {
      delete this.ngModel.id_persona;
      if (this.ngModel.tipo_documento === 'PASAPORTE') {
        delete this.ngModel.nombres;
        delete this.ngModel.primer_apellido;
        delete this.ngModel.segundo_apellido;
        delete this.ngModel.casada_apellido;
      }
}

    isDisabled() {
        return angular.isUndefined(this.ngModel.documento_identidad)  || !this.Datetime.isDate(this.ngModel.fecha_nacimiento);
    }

    search() {
      var query = `tipo_documento=${this.ngModel.tipo_documento}`;
      query = `${query}&documento_identidad=${this.ngModel.documento_identidad}`;
      query = `${query}&fecha_nacimiento=${this.Datetime.format(this.ngModel.fecha_nacimiento,'YYYY/MM/dd')}`;
      query = `${query}&nombres=${this.ngModel.nombres || ''}`;
      query = `${query}&primer_apellido=${this.ngModel.primer_apellido || ''}`;
      query = `${query}&segundo_apellido=${this.ngModel.segundo_apellido || ''}`;
      this.DataService.get(`persona/servicio/contrastar?${query}`)
      .then( response => {
        delete this.ngModel.id_persona;
        if (response) {
          this.ngModel.primer_apellido = response.primer_apellido;
          this.ngModel.segundo_apellido = response.segundo_apellido;
          this.ngModel.nombres = response.nombres;
          this.ngModel.id_persona = response.id_persona;
        }
      });
    }
}

export default DocumentoIdentidadContrastacionController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/documentoIdentidadContrastacion/documentoIdentidadContrastacion.controller.js